// 用户模块接口
import request from '@/utils/request'

// 用户注册
export const registerUserInfo = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/registerAccount',
		method: 'post',
		data
	})
}

// 用户登录
export const userLogin = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/login',
		method: 'post',
		data
	})
}

/**
 * 统一身份认证登录跳转地址。
 *
 * 该地址由后端提供，浏览器直接访问即可进入统一身份认证平台，
 */
export function unifiedAuthLoginUrl() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SYSTEM + '/hbzww/system/cjt/uiasLogin'
}

/**
 * 使用统一身份认证回调令牌换取楚建通用户登录信息。
 *
 * 入参：{ userCode, captchaId }
 * 约定返回：{ data: { token, userId, userType } }
 */
export const getOAuthInfo = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/hbzww/system/cjt/getUserInfo',
		method: 'get',
		headers: {
			isToken: false
		},
		params
	})
}

// 获取登陆验证码
export function getCaptcha(captchaId) {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/admin/captcha.jpg?captchaId=' + captchaId
}

// 发送短信验证码
export const sendMsgAuthCode = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MESSAGE + '/api/sysMessage/sendMsgAuthCode',
		method: 'post',
		data
	})
}

// 忘记密码
export const forgetPassword = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/sysUser/forgetPassword',
		method: 'post',
		data
	})
}

// 修改用户信息（包括密码、手机号等）
export const updateUser = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/updateUser',
		method: 'post',
		headers: {
			isToken: true
		},
		data
	})
}
